<template>
  <v-btn
      :outlined="outlined"
      :large="large"
      :absolute="absolute"
      :right="right"
      :left="left"
      :top="top"
      :bottom="bottom"
      :color="color"
      :loading="loading"
      :rounded="rounded"
      small
      class="origin-btn"
      :class="['btntype-'+type]"
      :elevation="elevation"
      :height="height"
      :min-width="minWidth"
      :width="width"
      :style="{ 'border-radius': radius }"
      :block="block"
      :disabled="disabled"
      @click="eventClick"
  >
    <v-icon class="mr-2" v-if="prependIcon">{{ prependIcon }}</v-icon>
    <v-img
        v-if="prependResIcon"
        :width="resSize"
        :max-width="resSize"
        :max-height="resSize"
        contain
        class="mr-2"
        :src="prependResIcon"
    ></v-img>
    <div class="txt-bigger" style="letter-spacing: 0">{{ $t(label) }}</div>
    <slot v-if="!label"></slot>
    <v-icon v-if="icon" color="var(--nn-darkgreen)">{{ icon }}</v-icon>
    <v-icon v-if="appendIcon" class="ml-2">{{ appendIcon }}</v-icon>
    <v-img
        v-if="appendResIcon"
        :width="resSize"
        :max-width="resSize"
        :max-height="resSize"
        contain
        class="ml-2"
        :src="appendResIcon"
    ></v-img>
  </v-btn>
</template>

<script>
export default {
  name: 'Button',
  props: {
    label: {
      default: ''
    },
    elevation: {
      default: 0
    },
    loading: {
      default: false
    },
    color: {
      default: 'var(--theme-color-one)'
    },
    rounded: {
      default: false
    },
    minWidth: {
      default: '50px'
    },
    absolute: {
      default: false
    },
    right: {
      default: false
    },
    left: {
      default: false
    },
    top: {
      default: false
    },
    bottom: {
      default: false
    },
    outlined: {
      default: false
    },
    large: {
      default: false
    },
    block: {
      default: false
    },
    width: {
      default: 'unset'
    },
    height: {
      default: '36px'
    },
    radius: {
      default: '10px'
    },
    disabled: {
      default: false
    },
    icon: {
      default: undefined
    },
    prependIcon: {
      default: undefined
    },
    prependResIcon: {
      default: undefined
    },
    appendIcon: {
      default: undefined
    },
    appendResIcon: {
      default: undefined
    },
    resSize: {
      default: '25px'
    },
    type: {
      default: '2'
    }
  },
  methods: {
    eventClick() {
      this.$emit('onClick')
    }
  }
}
</script>

<style scoped lang="scss">
.btntype-1 {
  color: #fff !important;
  padding: 0 8px !important;
  &:not(.v-btn--disabled) {
    background: linear-gradient(180deg, #127B9E 0%, #006081 100%);
  }
}

.btntype-2 {
  color: #fff !important;
  padding: 0 8px !important;
  &:not(.v-btn--disabled) {
    background: var(--theme-color-one);
  }
}
.btntype-2-icon {
  color: #fff !important;
  padding: 0 16px 0 8px !important;
  &:not(.v-btn--disabled) {
    background: var(--theme-color-one);
  }
}

.btntype-3 {
  color: #fff !important;
  padding: 0 8px !important;
  &:not(.v-btn--disabled) {
    background: linear-gradient(180deg, #32C397 0%, #24B287 100%);
  }
}

.btntype-4 {
  color: #fff !important;
  padding: 0 8px !important;
  &:not(.v-btn--disabled) {
    background: linear-gradient(180deg, #A1C7D3 0%, #93BAC7 100%);
  }
}

.btntype-5 {
  color: #fff !important;
  padding: 0 8px !important;
  &:not(.v-btn--disabled) {
    background: linear-gradient(180deg, #FF5D43 0%, #E4533C 100%);
  }
}

.btntype-6-icon {
  color: var(--theme-color-three) !important;
  padding: 0 16px 0 8px !important;
  &:not(.v-btn--disabled) {
    background: var(--theme-color-four) !important;
  }
}

.btntype-7 {
  color: #fff !important;
  padding: 0 8px !important;
  &:not(.v-btn--disabled) {
    background: linear-gradient(180deg, #48B8DF 0%, #3EAACF 100%);
  }
}

.btntype-7-icon {
  color: #fff !important;
  padding: 0 16px 0 8px !important;
  &:not(.v-btn--disabled) {
    background: linear-gradient(180deg, #48B8DF 0%, #3EAACF 100%);
  }
}
.btntype-8 {
  color: #000 !important;
  padding: 0 8px !important;
  &:not(.v-btn--disabled) {
    background: #fff !important;
  }
}
.btntype-9 {
  color: var(--theme-color-eight) !important;
  padding: 0 8px !important;
  &:not(.v-btn--disabled) {
    border: solid 1px var(--theme-color-eight) !important;
    background: transparent !important;
  }
}
</style>
